module.exports = __webpack_public_path__ + "media/images/div_lens/relatable-BGImg-4355feb3aefaa8d23f93db3ad700cb53.jpg";